// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Mirrors the single-view game grid (ReactVirtualVerticalGrid): identical
 * column counts, gaps and padding per breakpoint so this section is laid out
 * exactly like every other single-view section. The cards fill their columns
 * (TopWinFeaturedCard drops its max-width via [data-view='single']).
 *
 * Reference values:
 *   columns  <389:2  389–575:3  576–1025:4  1026–1279:5  1280–1599:6  ≥1600:auto-fill(220px)
 *   gap      <1025: 8px        ≥1025: 10px   (GRID_GAP)
 *   padding  <1025: 8px        ≥1025: 20px   horizontal, 8px bottom, 0 top
 */
.aasMLcXdH1tl4PXnLjL3 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  padding: 0 8px 8px;
  box-sizing: border-box;
  width: 100%;
}
@media (min-width: 389px) {
  .aasMLcXdH1tl4PXnLjL3 {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 576px) {
  .aasMLcXdH1tl4PXnLjL3 {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1025px) {
  .aasMLcXdH1tl4PXnLjL3 {
    gap: 10px;
    padding: 0 20px 8px;
  }
}
@media (min-width: 1026px) {
  .aasMLcXdH1tl4PXnLjL3 {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1280px) {
  .aasMLcXdH1tl4PXnLjL3 {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (min-width: 1600px) {
  .aasMLcXdH1tl4PXnLjL3 {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/topWins/components/SingleViewTopWins/SingleViewTopWins.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;AACF;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,SAAS;IACT,mBAAmB;EACrB;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,4DAA4D;IAC5D,uBAAuB;EACzB;AACF","sourcesContent":["/*\n * Mirrors the single-view game grid (ReactVirtualVerticalGrid): identical\n * column counts, gaps and padding per breakpoint so this section is laid out\n * exactly like every other single-view section. The cards fill their columns\n * (TopWinFeaturedCard drops its max-width via [data-view='single']).\n *\n * Reference values:\n *   columns  <389:2  389–575:3  576–1025:4  1026–1279:5  1280–1599:6  ≥1600:auto-fill(220px)\n *   gap      <1025: 8px        ≥1025: 10px   (GRID_GAP)\n *   padding  <1025: 8px        ≥1025: 20px   horizontal, 8px bottom, 0 top\n */\n.grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n  padding: 0 8px 8px;\n  box-sizing: border-box;\n  width: 100%;\n}\n@media (min-width: 389px) {\n  .grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@media (min-width: 576px) {\n  .grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n@media (min-width: 1025px) {\n  .grid {\n    gap: 10px;\n    padding: 0 20px 8px;\n  }\n}\n@media (min-width: 1026px) {\n  .grid {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n@media (min-width: 1280px) {\n  .grid {\n    grid-template-columns: repeat(6, 1fr);\n  }\n}\n@media (min-width: 1600px) {\n  .grid {\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `aasMLcXdH1tl4PXnLjL3`
};
export default ___CSS_LOADER_EXPORT___;
